

/// <reference path="StockNoteProductLine.ts" />

// Generated class CustomInputNoteLine_ManagedObject

class CustomInputNoteLine_ManagedObject extends StockNoteProductLine
{
}
